const MedicalIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    {...props}>
    <g
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.02}
      clipPath='url(#medical-black_svg__a)'>
      <path d='M19.034 13.213V7.118h-5.81v6.095H7.129v5.81h6.095v6.095h5.81v-6.095h6.095v-5.81z' />
      <path d='M26.532 26.2c5.852-5.791 5.91-15.123.13-20.843S11.45-.305 5.596 5.486c-5.852 5.79-5.91 15.123-.13 20.843S20.68 31.99 26.532 26.2Z' />
    </g>
    <defs>
      <clipPath id='medical-black_svg__a'>
        <path fill='#fff' d='M0 0h32v32H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default MedicalIcon
